module.exports = require("lodash/isFunction");


//////////////////
// WEBPACK FOOTER
// external "lodash/isFunction"
// module id = 36
// module chunks = 0 1 2 3 4 5 6 7 10 11